"use strict";
/*
 * Created on 10. 3. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Configuration of {@link Promotion} manual splits for application subdomain.
 *
 * @author Tomas Leity
 */


var ManualSplitsAppConfig =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ManualSplitsAppConfig, _DomainObject_1$Domai);

  /**
   * @param enabled whether {@link Promotion} manual split feature is enabled
   */
  function ManualSplitsAppConfig(enabled) {
    var _this;

    _classCallCheck(this, ManualSplitsAppConfig);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ManualSplitsAppConfig).call(this));
    _this.enabled = enabled;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(ManualSplitsAppConfig, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ManualSplitsAppConfig(mat.enabled);
    }
  }]);

  return ManualSplitsAppConfig;
}(DomainObject_1.DomainObject);

exports.ManualSplitsAppConfig = ManualSplitsAppConfig;

ManualSplitsAppConfig.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ManualSplitsAppConfig.name);
  return {
    enabled: builder.bool('enabled')
  };
}();